import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";
import FeaturedInItem from "../components/featured-in-item";

export default function FeaturedIn() {
  const [page, setPage] = useState({});
  const [posts, setPosts] = useState([]);
  const [pageMedia, setPageMedia] = useState([]);
  const [loading, setLoading] = useState({});
  let { getMetaSnippet, getSeoTitle, getSeoDescription } = useUtilities();

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "featured-in"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};

        setPage(pageResponse);

        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.CATEGORIES("?slug=featured-in"))
      .then((res) => {
        const categoryId = res.data?.[0]?.id;
        if (!categoryId) return Promise.resolve({ data: [] });
        return axios.get(
          CONTENT_ROUTES.POSTS(
            `?categories=${categoryId}&_embed&orderby=date&order=desc&per_page=100`,
          ),
        );
      })
      .then((res) => {
        if (res) setPosts(res.data);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>{getSeoTitle(page, `Featured in - Nant Power`)}</title>
        <meta
          name="description"
          content={getSeoDescription(
            page,
            `Stay up-to-date with the latest news, trends, and expert insights in infrastructure investments. Explore expert analysis, updates, and in-depth articles on industry developments.`
          )}
        />
      </Helmet>

      <Header />
      <main>
        <section className="bg-white md:pt-16 pt-8 md:pb-8 pb-4">
          <div className="container mx-auto md:px-0 px-8">
            <div className="text-base leading-7 ">
              <h1 className="text-4xl font-medium mb-2">
                {page?.title?.rendered}
              </h1>
              <div
                className="text-[#58b947] text-2xl font-medium"
                dangerouslySetInnerHTML={{
                  __html: page?.content?.rendered,
                }}
              />
            </div>
          </div>
        </section>

        <section className="bg-white pb-16">
          <div className="container mx-auto md:px-0 px-8">
            <div className="mx-auto gap-y-8">
              {posts?.map((article, i) => (
                <Fragment key={i}>
                  <FeaturedInItem article={article} size={"normal"} />
                </Fragment>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
